/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import { func } from 'prop-types';
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import useInput from '../hooks/useInput';
import AuthedContext from '../contexts/AuthedContext';
// import usePrevious from '../hooks/usePrevious';
import {
  postBookingManual,
  getPriceList,
  putAccessToken,
} from '../utils/api';
import SubsidyToggler from '../components/SubsidyToggler';
import ShipRouteFilter from '../components/ShipRouteFilter';
import DepartHourFilter from '../components/DepartHourFilter';
import ShipFilter from '../components/ShipFilter';

function BookingManual({ setInitiate }) {
  const { authedUser } = useContext(AuthedContext);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [bookVipQuantity, setBookVipQuantity] = useInput(0);
  const [bookVipPrices, setBookVipPrices] = useInput(0);
  const [bookEconomyQuantity, setBookEconomyQuantity] = useInput(0);
  const [bookEconomyPrices, setBookEconomyPrices] = useInput(0);
  const [bookNonticketQuantity, setBookNonticketQuantity] = useInput(0);
  const [bookNonticketPrices, setBookNonticketPrices] = useInput(0);
  const [bookFreeQuantity, setBookFreeQuantity] = useInput(0);

  const [subsidyStatus, setSubsidyStatus] = useState(false);
  const [prices, setPrices] = useState(null);

  // const [agencyId, setAgencyId] = useInput(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [shipRouteId, setShipRouteId] = useInput('');
  const [shipId, setShipId] = useInput('');
  const [departHour, setDepartHour] = useInput('');

  // const prevSubsidyStatus = usePrevious(subsidyStatus);

  const emptyInputFields = () => {
    setBookVipQuantity(0);
    setBookEconomyQuantity(0);
    setBookNonticketQuantity(0);
    setBookNonticketPrices(0);
    setBookFreeQuantity(0);
  };

  const toggleSubsidyStatus = () => {
    setSubsidyStatus(!subsidyStatus);
  };

  // console.log('curent subsidy: ' + subsidyStatus);
  // console.log('prev subsidy: ' + prevSubsidyStatus);
  const submitHandler = (event) => {
    event.preventDefault();

    if (!bookVipQuantity && !bookEconomyQuantity && !bookNonticketQuantity && !bookFreeQuantity) {
      Swal.fire(
        'Konfirmasi Gagal!',
        'Silahkan lakukan penginputan data terlebih dahulu',
        'error',
      );

      return 0;
    }

    if (authedUser.role === 'master' || authedUser.role === 'admin') {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Confirm!',
      }).then((result) => {
        if (result.isConfirmed) {
          const requestData = {
            date: moment(selectedDate).format('YYYY-MM-D'),
            ship_route_id: shipRouteId,
            ship_id: shipId,
            book_vip_quantity: bookVipQuantity * 1,
            book_vip_prices: bookVipPrices,
            book_economy_quantity: bookEconomyQuantity * 1,
            book_economy_prices: bookEconomyPrices,
            book_nonticket_quantity: bookNonticketQuantity * 1,
            book_nonticket_prices: bookNonticketPrices,
            book_free_quantity: bookFreeQuantity * 1,
            operator_id: authedUser.id * 1,
          };

          postBookingManual(requestData).then(({ statusCode, message }) => {
            if (statusCode === 201) {
              Swal.fire(
                'Success',
                'Tiket berhasil di input',
                'success',
              );
              emptyInputFields();
            } else if (statusCode === 401) {
              Swal.fire(
                'Failed',
                'Session anda telah habis, silahkan login kembali',
                'error',
              );
              putAccessToken('');
              setInitiate(true);
            } else {
              if (statusCode === 409) {
                Swal.fire(
                  'Insert Failed!',
                  'Data already exist!',
                  'error',
                );
                window.location.reload();
                return;
              }
              Swal.fire(
                'Insert Failed!',
                message,
                'error',
              );
            }
          });
        }
      });
    } else {
      alert('Anda tidak memiliki akses pada fitur tersebut');
    }

    return 1;
  };

  useEffect(() => {
    if (shipRouteId) {
      getPriceList(shipRouteId).then(({ errorMessage, data }) => {
        if (!data) {
          alert(errorMessage);
        } else {
          setPrices({
            vip: data.adult_vip,
            economy: data.adult_executive,
            vipSubsidy: data.subsidy_adult_vip,
            economySubsidy: data.subsidy_adult_executive,
          });
        }
      });
    }
  }, [shipRouteId, subsidyStatus]);

  useEffect(() => {
    if (prices) {
      if (subsidyStatus) {
        setBookVipPrices(bookVipQuantity * prices.vipSubsidy);
        setBookEconomyPrices(bookEconomyQuantity * prices.economySubsidy);
      } else {
        setBookVipPrices(bookVipQuantity * prices.vip);
        setBookEconomyPrices(bookEconomyQuantity * prices.economy);
      }
    }
  }, [bookVipQuantity, bookEconomyQuantity, subsidyStatus]);

  useEffect(() => {
    // if (prevSubsidyStatus === subsidyStatus) {}
    emptyInputFields();
  }, [prices]);

  useEffect(() => {
    setTotalPrice((bookVipPrices + bookEconomyPrices + bookNonticketPrices * 1).toLocaleString('id-ID'));
  }, [bookVipPrices, bookEconomyPrices, bookNonticketPrices]);

  return (
    <section>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="row align-items-center">
            <div className="col-12 mb-2 d-flex justify-content-center">
              <DatePicker
                className="text-center"
                selected={selectedDate}
                minDate={new Date()}
                onChange={(date) => setSelectedDate(date)}
                inline
              />
            </div>
            <div className="col-sm-2 mb-2">
              <SubsidyToggler subsidy={subsidyStatus} toggleSubsidy={toggleSubsidyStatus} />
            </div>
            <div className="col-sm-4 col-md-2 mb-2">
              {
                shipRouteId && (
                  <DepartHourFilter
                    selectedId={departHour}
                    setSelectedId={setDepartHour}
                    routeId={shipRouteId}
                  />
                )
              }
            </div>
            <div className="col-sm-6 col-md-4 mb-2">
              <ShipRouteFilter selectedId={shipRouteId} setSelectedId={setShipRouteId} />
            </div>
            <div className="col-sm-12 col-md-4 mb-2">
              <ShipFilter selectedId={shipId} setSelectedId={setShipId} routeId={shipRouteId} />
            </div>
            <div className="col-12">
              <form onSubmit={submitHandler}>
                <div className="alert alert-success text-center" role="alert">
                  { `Total Harga : Rp. ${totalPrice}` }
                </div>
                <label className="my-3">{`Tanggal Keberangkatan : ${selectedDate}`}</label>

                <br />

                <div className="row align-items-center g-3 mt-2">
                  <div className="col-2">Jenis Tiket</div>
                  <div className="col-5">Jumlah Tiket</div>
                  <div className="col-5">Harga Tiket</div>

                  <div className="col-2">VIP :</div>
                  <div className="col-5">
                    <input className="form-control" type="number" min="0" onChange={setBookVipQuantity} value={bookVipQuantity} />
                  </div>
                  <div className="col-5">
                    <input className="form-control" type="number" min="0" value={bookVipPrices} readOnly />
                  </div>

                  <div className="col-2">Ekonomi :</div>
                  <div className="col-5">
                    <input className="form-control" type="number" min="0" onChange={setBookEconomyQuantity} value={bookEconomyQuantity} />
                  </div>
                  <div className="col-5">
                    <input className="form-control" type="number" min="0" value={bookEconomyPrices} readOnly />
                  </div>

                  <div className="col-2">Non Tiket :</div>
                  <div className="col-5">
                    <input className="form-control" type="number" min="0" onChange={setBookNonticketQuantity} value={bookNonticketQuantity} />
                  </div>
                  <div className="col-5">
                    <input className="form-control" type="number" min="0" onChange={setBookNonticketPrices} value={bookNonticketPrices} />
                  </div>

                  <div className="col-2">Free :</div>
                  <div className="col-5">
                    <input className="form-control" type="number" min="0" onChange={setBookFreeQuantity} value={bookFreeQuantity} />
                  </div>
                </div>

                <button type="submit" className="btn btn-primary mt-4 rounded-1">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

BookingManual.propTypes = {
  setInitiate: func.isRequired,
};

export default BookingManual;
